import { Stack, Text, getTheme } from '@fluentui/react';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import React from 'react';




export class ContentPane extends React.Component<ContentPaneProps, {}> {

    render() {
        let theme = getTheme();
        return <Stack style={{ boxShadow: Depths.depth4,paddingLeft:10,paddingRight:10,margin:15,backgroundColor:theme.palette.white }} >
            <Stack horizontal verticalAlign={"baseline"} tokens={{childrenGap:5}}><h1>{this.props.headerText}</h1><Text variant={"small"}>{this.props.subHeaderText}</Text></Stack>
            <Text>{this.props.description}</Text>
            {this.props.children}
        </Stack>;
    }

};

interface ContentPaneProps {
    headerText?: string,
    subHeaderText?: string,
    description?:string
  }
